module.exports = __webpack_public_path__ + "f400a99e9f1e932e77754e28fd4a6817.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/chunky-gem-earrings.png
// module id = 2785
// module chunks = 0